var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{staticClass:"m-1 regular",attrs:{"color":_vm.colorStatus(_vm.status),"dark":""}},[_vm._v(" "+_vm._s(_vm.nameStatus(_vm.status))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }